export default __webpack_public_path__ + "static/media/AC.a77eef12.svg";